import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

export const Breadcrumbs = () => {
  const location = useLocation();
  const { menus } = useAuth();
  const currentPath = location.pathname;

  // Resolve matching menu item and its parent group title
  let parentSection = null;
  let activeMenuItem = null;

  if (menus && Array.isArray(menus)) {
    for (const group of menus) {
      if (group.children) {
        const found = group.children.find((child) => child.path === currentPath);
        if (found) {
          parentSection = group.title;
          activeMenuItem = found.title;
          break;
        }
      } else if (group.path === currentPath) {
        activeMenuItem = group.title;
        break;
      }
    }
  }

  // Fallback for unmapped routes
  if (!activeMenuItem) {
    if (currentPath === '/dashboard') {
      activeMenuItem = 'Dashboard';
    } else {
      const slug = currentPath.split('/').filter(Boolean).pop() || '';
      activeMenuItem = slug
        .replace(/-/g, ' ')
        .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
    }
  }

  return (
    <nav className="flex items-center" aria-label="Breadcrumb">
      <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-100/90 dark:bg-slate-800/70 border border-slate-200/70 dark:border-slate-700/60 shadow-xs backdrop-blur-sm text-xs select-none">
        {/* Home Link */}
        <Link
          to="/dashboard"
          className="flex items-center gap-1 text-slate-500 dark:text-slate-400 hover:text-red-600 dark:hover:text-red-400 font-medium transition-colors"
          title="Go to Dashboard"
        >
          <span className="material-icons text-sm text-slate-400 dark:text-slate-400">home</span>
          <span>Home</span>
        </Link>

        {/* Parent Group Crumb */}
        {parentSection && (
          <>
            <span className="material-icons text-slate-400 text-xs leading-none">chevron_right</span>
            <span className="text-slate-500 dark:text-slate-400 font-medium capitalize">
              {parentSection.toLowerCase()}
            </span>
          </>
        )}

        {/* Active Page Crumb */}
        {currentPath !== '/dashboard' && activeMenuItem && (
          <>
            <span className="material-icons text-slate-400 text-xs leading-none">chevron_right</span>
            <span className="font-bold text-slate-800 dark:text-slate-100">
              {activeMenuItem}
            </span>
          </>
        )}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
